var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-icon-reply",on:{"click":_vm.reply}},[_c('img',{staticClass:"f-icon-reply-img",attrs:{"src":_vm.icon}}),_c('span',{staticClass:"f-icon-reply-word"},[_vm._v(_vm._s(_vm.boardInfo.id === 1 ? '回答' : '回复'))])])}
var staticRenderFns = []

export { render, staticRenderFns }